import React from 'react';
import { Phone, ChevronDown } from 'lucide-react';
import { restaurantInfo } from '../data/mockData';
import { Badge } from './ui/badge';

export const Hero = () => {
  const scrollToMenu = (e) => {
    e.preventDefault();
    const menuSection = document.querySelector('#menu');
    if (menuSection) {
      const offset = 80;
      const elementPosition = menuSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1706713417278-f56e1fd147e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxkYXJrJTIwd29vZCUyMGZsYW1lc3xlbnwwfHx8fDE3NjI4NzcwMjh8MA&ixlib=rb-4.1.0&q=85)'
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-32">
        {/* Logo */}
        <div className="mb-12 flex justify-center">
          <img
            src="https://customer-assets.emergentagent.com/job_8245d813-8efc-41f6-a3d6-f99a51340e33/artifacts/qayef3uh_ChatGPT%20Image%206%20avr.%202026%2C%2016_23_18.png"
            alt="Le Tassili Logo"
            className="w-64 md:w-80 h-auto"
          />
        </div>

        {/* Main Title */}
        <h1
          className="text-5xl md:text-7xl font-bold text-white mb-6"
          style={{ fontFamily: "'Crimson Text', 'Times New Roman', serif" }}
        >
          Le Tassili – {restaurantInfo.location}
        </h1>

        {/* Tagline */}
        <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto leading-relaxed">
          {restaurantInfo.tagline}
        </p>

        {/* Badges */}
        <div className="flex justify-center gap-3 mb-10">
          <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full flex items-center gap-3 border-2 border-white/20">
            <img 
              src="https://customer-assets.emergentagent.com/job_le-tassili-resto/artifacts/442clmj3_pngtree-green-circle-halal-logo-png-image_6089860.png"
              alt="Halal"
              className="w-10 h-10"
            />
            <span className="text-white font-bold text-lg">100% HALAL</span>
          </div>
        </div>

        {/* Livraison Banner */}
        <div className="mb-10 flex justify-center">
          <div className="bg-gradient-to-r from-[#D4A85F] to-[#E2B978] px-8 py-4 rounded-xl shadow-2xl inline-flex items-center gap-4">
            <div className="bg-black/20 p-3 rounded-full">
              <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
              </svg>
            </div>
            <div>
              <p className="text-black font-bold text-2xl">Livraison seulement à : 0,80€</p>
            </div>
          </div>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a
            href={restaurantInfo.phoneLink}
            className="inline-flex items-center gap-2 bg-[#D4A85F] text-black px-8 py-4 rounded-md font-bold text-lg hover:bg-[#E2B978] transition-all duration-200 w-full sm:w-auto justify-center"
          >
            <Phone size={20} />
            Appeler maintenant
          </a>
          <a
            href="#menu"
            onClick={scrollToMenu}
            className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-white hover:text-black transition-all duration-200 w-full sm:w-auto justify-center"
          >
            Voir le menu
          </a>
        </div>

        {/* Quick Info */}
        <div className="text-white space-y-2">
          <p className="text-lg font-medium">
            <a href={restaurantInfo.phoneLink} className="hover:text-[#ECEC75] transition-colors">
              {restaurantInfo.phoneDisplay}
            </a>
            {restaurantInfo.phoneSecondary && (
              <>
                {" ou "}
                <a href={`tel:${restaurantInfo.phoneSecondary.replace(/\s/g, '')}`} className="hover:text-[#ECEC75] transition-colors">
                  {restaurantInfo.phoneSecondary}
                </a>
              </>
            )}
          </p>
          <p className="text-sm text-gray-300">
            Lun-Sam: 11:45–14:20, 18:00–22:20 | Dim: 18:00–22:20
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-white" size={32} />
      </div>
    </section>
  );
};
